import { render } from "./EyeSvg.vue?vue&type=template&id=2ca5285e"
import script from "./EyeSvg.vue?vue&type=script&lang=js"
export * from "./EyeSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__